import { NgModule } from '@angular/core';
import { DpadContainerDirective } from './directives/dpad-container.directive';
import { DpadZoneDirective } from './directives/dpad-zone.directive';
import { DpadSelectableDirective } from './directives/dpad-selectable.directive';
import { DpadScrollableVerticalDirective } from './directives/dpad-scrollable-vertical.directive';
import { DpadScrollableHorizontalDirective } from './directives/dpad-scrollable-horizontal.directive';


@NgModule({
    declarations: [
        DpadContainerDirective,
        DpadZoneDirective,
        DpadSelectableDirective,
        DpadScrollableVerticalDirective,
        DpadScrollableHorizontalDirective,
    ],
    imports: [
    ],
    exports: [
        DpadContainerDirective,
        DpadZoneDirective,
        DpadSelectableDirective,
        DpadScrollableVerticalDirective,
        DpadScrollableHorizontalDirective,
    ]
})
export class ProtoDpadNavigationModule {
}
